import { FieldTitle } from './RedStarTitle';
import Select from 'react-select';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldDesc } from './common';
import { TextField } from '@client/new/components/basic';
import { OfferDetailsData } from './OfferDetails.mappers';
import { TogglableButtons } from '@design-system/components/togglableButtons';

export function OfferDetailsSection({
  index,
  offerData,
}: {
  index: number;
  offerData?: OfferDetailsData;
}) {
  const { register, control } = useFormContext();
  const r = (s: string) => register(`sections.${index}.${s}`);

  return (
    <div className="w-100">
      <div className="max-w-[680px]">
        {/* 1. Headline Text */}
        <div>
          <FieldTitle title={'Headline text'} />
          <FieldDesc>
            The headline is used to communicate the offer&apos;s value
            proposition.
          </FieldDesc>
          <TextField
            {...r(`headlineText`)}
            className="mb-[5px] max-w-[680px] w-full"
            inputProps={{
              placeholder: 'Headline text',
              maxLength: 60,
            }}
          />
        </div>

        {/* 2. Programs Multi-Select */}
        <div className="mt-8">
          <FieldTitle title={'Choose Programs'} optional />
          <FieldDesc>
            Select the programs included in this offer. They will be displayed
            in the order selected.
          </FieldDesc>
          <Controller
            name={`sections.${index}.programIds`}
            control={control}
            render={({ field: { value, onChange, ref } }) => (
              <Select
                ref={ref}
                isMulti
                options={offerData?.programIds.options || []}
                value={(offerData?.programIds.options || []).filter((option) =>
                  (value || []).includes(option.value),
                )}
                onChange={(selected) =>
                  onChange(selected?.map((s) => s.value) || [])
                }
                placeholder="Select programs..."
              />
            )}
          />
        </div>

        {/* 3. Extras Multi-Select */}
        <div className="mt-8">
          <FieldTitle title={'Choose Extras'} optional />
          <FieldDesc>
            Select the extra content items included in this offer.
          </FieldDesc>
          <Controller
            name={`sections.${index}.extrasIds`}
            control={control}
            render={({ field: { value, onChange, ref } }) => (
              <Select
                ref={ref}
                isMulti
                options={offerData?.extrasIds.options || []}
                value={(offerData?.extrasIds.options || []).filter((option) =>
                  (value || []).includes(option.value),
                )}
                onChange={(selected) =>
                  onChange(selected?.map((s) => s.value) || [])
                }
                placeholder="Select extras..."
              />
            )}
          />
        </div>

        {/* 4. Community Features Togglable Buttons */}
        <div className="mt-8">
          <FieldTitle title={'Community Features'} optional />
          <FieldDesc>
            Select the community features included in this offer.
          </FieldDesc>
          <Controller
            name={`sections.${index}.communityFeatures`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <TogglableButtons
                options={(offerData?.communityFeatures.options || []).map(
                  (option) => ({
                    value: option.value,
                    label: option.label,
                  }),
                )}
                value={value || []}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}
